import React from 'react';
import SideBanner from './../../components/sideBanner';
import SideBannerMobile from './../../components/sideBannerMobile';
import Button from './../../components/button';
import { connect } from 'react-redux'
import ReactHtmlParser from 'react-html-parser';
import { redirectTo, goBack } from './../../action/redirection'
import { Pages } from './../../constants/actionType';
import * as lqAction from './../../action/loopQual'
import { updateSCTags } from './../../service/dtmTag';
import { updatePageLogs, checktime } from './../../service/logService';
import { apiUrl } from './../../constants/apiUrl';
import { InHomeUtils } from '../../util/inhomeUtils';

class signIn extends React.PureComponent {
    onSelectSignin = (e) => {
        if (e.target.value === "AF") {
            updateSCTags("change service at current address");
        }
        //moveChange
        else if (e.target.value === "MV") {
            updateSCTags("move service to new address");
        }

        lqAction.onSelectSignin(e.target.value, this.props.dispatch);
    }
    onBackClick = (() => {
        const isECequalsYPrevPage = ((this.props.appState && this.props.appState.prevPage && this.props.appState.prevPage.search) || "").toLowerCase().indexOf('ec=y') > -1 ? true : false;
        if (this.props.appState && this.props.appState.prevPage && this.props.appState.prevPage.pathname === "/inhome/qualification" && isECequalsYPrevPage) {
            redirectTo(Pages.CheckLQ, this.props.dispatch);
        } else {
            //goBack - One Step Back from history
            goBack(this.props.dispatch);
        }
    })

    handleOnBackKeyDown(e) {
        if (e.keyCode === 13 || e.keyCode === 32) {
            this.onBackClick(e);
        }
    }

    signInClick = () => {
        let url = "";
        //const ismrftnew = (this.props.appState.prevPage.search || '').toLowerCase().indexOf('nurse=y') > -1 ? true : false;
        //const qsvalues = queryString.parse(this.props.appState.prevPage.search.toLowerCase());
        //let mfrtScope = qsvalues.nurse ? "nurse" : qsvalues.teacher ? "teacher" : qsvalues.responder ? "responder" : qsvalues.milvet ? 'milvet' : null;
        if (InHomeUtils.isNotNull(this.props.lqState) && this.props.lqState.signInAs === "AF") {
            updateSCTags("continue-change service");
            if(window.location.hostname === 'espanol.verizon.com' || window.location.hostname === 'espanolstage.verizon.com') 
            {
                url = apiUrl().MyVzSigninEspanolAFNew;
            }
            else {
                url = apiUrl().MyVzSigninAFNew;
            }
          
            if (this.props.lqState.doFlowDetails.isDoFlow && this.props.lqState.doFlowDetails.DOIDValue === 'FCP') {
                url += '?FlowRoute=CLASSICTOFCP&urcsource=nsmixmatchmlp';
            }

            if (InHomeUtils.isNotNull(this.props.lqState.MFRTEligible) && this.props.lqState.MFRTEligible) {
                url += '%25253fisMFRT%25253dy';
            }
            if (this.props.lqState.mfrtType) {
                //mfrtScope='nurse';
               // this.props.dispatch({ type: "UPDATE_MFRT_TYPE", value:"nurse" })
               //For EC TWS flow by deafault sending the  QS ECSmart as Y
                url = apiUrl().MyVzSigninInhomeAFNew + '%2526source%253durc%2526customerintent%253dACCORDION%2526subflowtype%253daccordion%2526' + this.props.lqState.mfrtType + '%253dy'+'%2526EnableSmartcart%253dy%2526enableinhomesmartcart%253dy';
            }
            window.location.assign(url);             
        }
        //moveChange
        else {
            updateSCTags("continue-move service");
            this.props.dispatch({ type: "UPDATE_FLOWTYPE", value: { flowType: "MV" } });
            this.props.dispatch({type: 'UPDATE_FLOWPURPOSE', value: { flowPurpose: "MV" }});
            redirectTo(Pages.MoveSignIn, this.props.dispatch)
        }
    }
    componentWillMount() {
        checktime(this.callCheckTime('WillMount'));
        let previousPage = this.props.appState.prevPage.pathname
        let currentPage = this.props.location.pathname;
        if (previousPage !== currentPage) {
            this.props.dispatch({ type: "PAGE_VISITID", value: { prevPage: this.props.appState.currentPage, currentPage: this.props.location } });
        }
    }

    callCheckTime = ((pagestate) => {
        return {
            page: 'signin',
            mount: (pagestate === 'Mount') && Date.now(),
            unmount: (pagestate === 'WillMount') && Date.now(),
            pageURL: window.location.href,
            visitid: this.props.appState.visitId || 'visit_id_not_created',
            noSSNCheck: false
        }
    })

    componentDidMount() {

        setTimeout(
            function () {
                checktime(this.callCheckTime('Mount'));
                updatePageLogs(this.props.appState, this.props.appState.visitId, false);
            }.bind(this), 500);
    }
    render() {
        let descriptionmsg = "Please select if you would like to <strong>change</strong> <br/> or <strong>move</strong> your existing service.";
        return (
            <div className="padding-all-zero inherit-height m_lq-main full-page-lq" style={{ overflowY: 'auto', height: '100%' }}>
                <div className="margin-bottom-zero overlay-set-height1 m_page-height">
                    <div className="inherit-height page active">
                        <div className="inherit-height CA">
                            <div className="row margin-vert-zero loop-qualification  medium-vert-middle minHeight300 overlay-address-section">
                                <SideBanner bannerText="Sign in." />
                                <div className="column tiny-12 loop-qualification_right medium-10" data-lq-form-right>
                                    <div className="row margin-vert-zero loop-qualification_address-field" data-address-form>
                                        <div className="column padding-vert-zero timy-12 medium-12" style={{ height: '100%' }}>
                                            <div className="row margin-vert-zero padding-horiz-tiny" >
                                                <div className="column tiny-12 medium-12 padding-vert-zero" data-go-back onKeyDown={(e) => this.handleOnBackKeyDown(e)} onClick={this.onBackClick}>
                                                    <div className="inline pointer" tabIndex="0">
                                                        <span className="vzicon icon-previous text-black small middle"></span>
                                                        <span aria-label="Back button" className="bold padding-left-micro">Back</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <SideBannerMobile bannerText="Sign in." />
                                            <div className="row margin-vert-zero medium-vert-middle loop-qualification_address" id="loop-qual-adress-signin-change-addr">
                                                <div className="columns padding-vert-zero tiny-12 medium-12">
                                                    <div className="row margin-vert-zero p-100">
                                                        <div className="LQContentOnly">
                                                            <h6 id="existingCustomerDrop">
                                                                {ReactHtmlParser(descriptionmsg)}
                                                            </h6>
                                                            <select id="existingCustomer" className="tiny-12 medium-5 value" onChange={this.onSelectSignin} aria-labelledby="existingCustomerDrop">
                                                                <option value="AF" className="fancy-options_item selected">Change service at current address</option>
                                                                {/* //moveChange */}
                                                                <option value="MV" className="fancy-options_item">Move service to new address</option>
                                                            </select>
                                                            <div className="error-msg exOption">
                                                                Please select option
                                                            </div>
                                                        </div>
                                                        <div className="row margin-vert-zero">
                                                            <div className="column padding-left-zero padding-right-zero tiny-12 padding-top-zero padding-bottom-zero LQ_Button_Bottom">
                                                                <Button onClick={this.signInClick} buttonText="Continue" buttonStyle="button medium-p-auto text-center signin-continue" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        lqState: state.loopQual,
        appState: state.app
    }
}
export default connect(
    mapStateToProps,
)(signIn);